import { apiClient } from '../api/apiClient';

export const clubsService = {
    getClub(clubId) {
        return apiClient.get(`clubs/${clubId}`);
    },

    getClubStats() {
        return apiClient.get('clubs/stats');
    },

    getPublicClubProfile(clubKey) {
        return apiClient.get(`clubs/${encodeURIComponent(clubKey)}/public-profile`);
    },

    getSharedOffer(token) {
        return apiClient.get(`clubs/shared-offers/${encodeURIComponent(token)}`);
    },

    resolveSharedOffer(token) {
        return apiClient.get(`clubs/shared-offers/${encodeURIComponent(token)}/resolve`);
    },

    trackClubConversionEvent(clubId, payload) {
        return apiClient.post(`clubs/${clubId}/conversion-events`, { json: payload });
    },

    submitClubClaimRequest(clubId, payload) {
        return apiClient.post(`clubs/${clubId}/claim-request`, { json: payload });
    },

    createStand(payload) {
        return apiClient.post('stand', {
            headers: {
                Accept: 'application/json'
            },
            json: payload
        });
    },

    getStand(standId) {
        return apiClient.get(`stand/${standId}`);
    },

    getStandLaunchByCode(standCode) {
        return apiClient.get(`stand/code/${encodeURIComponent(standCode)}/launch`, { auth: false });
    },

    getClubStands(clubId) {
        return apiClient.get(`stand/club/${clubId}`);
    },

    getPublicClubStands(clubId) {
        return apiClient.get(`stand/club/${clubId}/public`, { auth: false });
    },

    getCourseLayout(clubId) {
        return apiClient.get(`stand/club/${clubId}/course-layout`);
    },

    saveCourseLayout(clubId, payload) {
        return apiClient.put(`stand/club/${clubId}/course-layout`, { json: payload });
    },

    updateStand(standId, payload) {
        return apiClient.put(`stand/${standId}`, { json: payload });
    },

    uploadStandPhoto(standId, formData) {
        return apiClient.post(`stand/${standId}/photos`, { body: formData });
    },

    deleteStandPhoto(standId, photoId) {
        return apiClient.del(`stand/${standId}/photos/${photoId}`);
    },

    addStandVideo(standId, payload) {
        return apiClient.post(`stand/${standId}/videos`, { json: payload });
    },

    deleteStandVideo(standId, videoId) {
        return apiClient.del(`stand/${standId}/videos/${videoId}`);
    },

    getFavoriteClubs() {
        return apiClient.get('clubs/favorite');
    },

    addFavoriteClub(clubId) {
        return apiClient.post('clubs/favorite', {
            json: { clubId }
        });
    },

    removeFavoriteClub(clubId) {
        return apiClient.del(`clubs/favorite/${clubId}`);
    },

    searchClubs(searchTerm) {
        return apiClient.get(`clubs/search?searchTerm=${encodeURIComponent(searchTerm)}`);
    },

    advancedSearch(params, options = {}) {
        return apiClient.get(`clubs/advanced-search?${params.toString()}`, options);
    },

    getLatestOffers(params) {
        return apiClient.get(`clubs/latest-offers?${params.toString()}`);
    },

    getManageClubs(params) {
        return apiClient.get(`clubuser/manage-clubs?${params.toString()}`);
    },

    createClub(payload) {
        return apiClient.post('clubs', { json: payload });
    },

    getClubMembers(clubId) {
        return apiClient.get(`clubuser/club/${clubId}/users`);
    },

    addClubMember(clubId, payload) {
        return apiClient.post(`clubuser/club/${clubId}/users`, { json: payload });
    },

    inviteClubMember(clubId, payload) {
        return apiClient.post(`clubuser/club/${clubId}/invitations`, { json: payload });
    },

    cancelClubInvitation(clubId, invitationId) {
        return apiClient.del(`clubuser/club/${clubId}/invitations/${invitationId}`);
    },

    getSharedClubInvitation(token) {
        return apiClient.get(`clubuser/invitations/shared/${encodeURIComponent(token)}`);
    },

    resolveSharedClubInvitation(token) {
        return apiClient.get(`clubuser/invitations/shared/${encodeURIComponent(token)}/resolve`);
    },

    acceptSharedClubInvitation(token) {
        return apiClient.post(`clubuser/invitations/shared/${encodeURIComponent(token)}/accept`);
    },

    updateClubMemberRole(clubId, memberId, payload) {
        return apiClient.put(`clubuser/club/${clubId}/users/${memberId}/role`, { json: payload });
    },

    removeClubMember(clubId, memberId) {
        return apiClient.del(`clubuser/club/${clubId}/users/${memberId}`);
    },

    getClubAdminEvents(clubId) {
        return apiClient.get(`clubadmin/club/${clubId}/events`);
    },

    getClubProfile(clubId) {
        return apiClient.get(`clubadmin/club/${clubId}/profile`);
    },

    updateClubProfile(clubId, payload) {
        return apiClient.put(`clubadmin/club/${clubId}/profile`, { json: payload });
    },

    createClubAdminEvent(clubId, payload) {
        return apiClient.post(`clubadmin/club/${clubId}/events`, { json: payload });
    },

    updateClubAdminEvent(clubId, eventId, payload) {
        return apiClient.put(`clubadmin/club/${clubId}/events/${eventId}`, { json: payload });
    },

    deleteClubAdminEvent(clubId, eventId) {
        return apiClient.del(`clubadmin/club/${clubId}/events/${eventId}`);
    },

    getClubPhotos(clubId) {
        return apiClient.get(`clubadmin/club/${clubId}/photos`);
    },

    getClubMaps(clubId) {
        return apiClient.get(`clubadmin/club/${clubId}/maps`);
    },

    getClubVideos(clubId) {
        return apiClient.get(`clubadmin/club/${clubId}/videos`);
    },

    uploadClubPhoto(clubId, formData) {
        return apiClient.post(`clubadmin/club/${clubId}/photos`, { body: formData });
    },

    uploadClubMap(clubId, formData) {
        return apiClient.post(`clubadmin/club/${clubId}/maps`, { body: formData });
    },

    addClubVideo(clubId, payload) {
        return apiClient.post(`clubadmin/club/${clubId}/videos`, { json: payload });
    },

    deleteClubPhoto(clubId, photoId) {
        return apiClient.del(`clubadmin/club/${clubId}/photos/${photoId}`);
    },

    deleteClubMap(clubId, mapId) {
        return apiClient.del(`clubadmin/club/${clubId}/maps/${mapId}`);
    },

    deleteClubVideo(clubId, videoId) {
        return apiClient.del(`clubadmin/club/${clubId}/videos/${videoId}`);
    },

    getClubDashboard(clubId) {
        return apiClient.get(`clubs/${clubId}`);
    },

    getClubSubscription(clubId) {
        return apiClient.get(`clubadmin/club/${clubId}/subscription`);
    },

    updateClubSubscription(clubId, payload) {
        return apiClient.put(`clubadmin/club/${clubId}/subscription`, { json: payload });
    },

    getClubAdminCrm(clubId) {
        return apiClient.get(`clubadmin/club/${clubId}/crm`);
    },

    updateClubAdminCrm(clubId, payload) {
        return apiClient.put(`clubadmin/club/${clubId}/crm`, { json: payload });
    },

    createClubAdminCrmNote(clubId, payload) {
        return apiClient.post(`clubadmin/club/${clubId}/crm/notes`, { json: payload });
    },

    createClubSubscriptionCheckoutSession(clubId, payload) {
        return apiClient.post(`clubadmin/club/${clubId}/subscription/checkout-session`, { json: payload });
    },

    syncClubSubscriptionCheckout(clubId, payload) {
        return apiClient.post(`clubadmin/club/${clubId}/subscription/sync-checkout`, { json: payload });
    },

    createClubSubscriptionPortalSession(clubId) {
        return apiClient.post(`clubadmin/club/${clubId}/subscription/portal`);
    },

    getClubConversionMetrics(clubId, days = 30) {
        return apiClient.get(`clubadmin/club/${clubId}/conversion-metrics?days=${days}`);
    },

    getClubTillProducts(clubId, includeInactive = false) {
        return apiClient.get(`clubtill/club/${clubId}/products?includeInactive=${includeInactive}`);
    },

    createClubTillProduct(clubId, payload) {
        return apiClient.post(`clubtill/club/${clubId}/products`, { json: payload });
    },

    updateClubTillProduct(clubId, productId, payload) {
        return apiClient.put(`clubtill/club/${clubId}/products/${productId}`, { json: payload });
    },

    getClubTillSales(clubId, take = 50) {
        return apiClient.get(`clubtill/club/${clubId}/sales?take=${take}`);
    },

    getClubTillSale(clubId, saleId) {
        return apiClient.get(`clubtill/club/${clubId}/sales/${saleId}`);
    },

    checkoutClubTill(clubId, payload) {
        return apiClient.post(`clubtill/club/${clubId}/checkout`, { json: payload });
    },

    createClubTillCardIntent(clubId, payload) {
        return apiClient.post(`clubtill/club/${clubId}/payments/card-intent`, { json: payload });
    },

    getClubTillCardIntentStatus(clubId, paymentIntentId) {
        return apiClient.get(`clubtill/club/${clubId}/payments/card-intent/${paymentIntentId}`);
    },

    getClubOffers(clubId) {
        return apiClient.get(`clubadmin/club/${clubId}/offers`);
    },

    createClubOffer(clubId, payload) {
        return apiClient.post(`clubadmin/club/${clubId}/offers`, { json: payload });
    },

    updateClubOffer(clubId, offerId, payload) {
        return apiClient.put(`clubadmin/club/${clubId}/offers/${offerId}`, { json: payload });
    },

    deleteClubOffer(clubId, offerId) {
        return apiClient.del(`clubadmin/club/${clubId}/offers/${offerId}`);
    },

    getClubPerkClaims(clubId, offerId) {
        return apiClient.get(`clubadmin/club/${clubId}/offers/${offerId}/claims`);
    },

    claimClubPerk(clubId, offerId, payload) {
        return apiClient.post(`clubadmin/club/${clubId}/offers/${offerId}/claims`, { json: payload });
    },

    getClubCommunications(clubId) {
        return apiClient.get(`clubadmin/club/${clubId}/communications`);
    },

    createClubCommunication(clubId, payload) {
        return apiClient.post(`clubadmin/club/${clubId}/communications`, { json: payload });
    },

    updateClubCommunication(clubId, communicationId, payload) {
        return apiClient.put(`clubadmin/club/${clubId}/communications/${communicationId}`, { json: payload });
    },

    sendClubCommunication(clubId, communicationId) {
        return apiClient.post(`clubadmin/club/${clubId}/communications/${communicationId}/send`);
    },

    getClubCommunicationDeliveries(clubId, communicationId) {
        return apiClient.get(`clubadmin/club/${clubId}/communications/${communicationId}/deliveries`);
    },

    exportClubCommunicationDeliveries(clubId, communicationId) {
        return apiClient.get(`clubadmin/club/${clubId}/communications/${communicationId}/deliveries/export`);
    },

    retryFailedClubCommunicationDeliveries(clubId, communicationId) {
        return apiClient.post(`clubadmin/club/${clubId}/communications/${communicationId}/retry-failed`);
    },

    resendFailedClubCommunicationDeliveries(clubId, communicationId) {
        return apiClient.post(`clubadmin/club/${clubId}/communications/${communicationId}/resend-failed`);
    },

    deleteClubCommunication(clubId, communicationId) {
        return apiClient.del(`clubadmin/club/${clubId}/communications/${communicationId}`);
    }
};
